// eslint-disable-next-line no-restricted-imports -- we use http by default
import http from 'hub-http/clients/apiClient';
import { registerQuery, useQuery } from 'data-fetching-client';
import { INCOMING_EMAIL, EMAIL, MEETING, FORWARDED_EMAIL, EMAIL_ACTIVITY, CUSTOM_CHANNEL_CONVERSATION } from 'customer-data-objects/engagement/EngagementTypes';
import { COMMUNICATION, MEETING_EVENT } from 'customer-data-objects/constants/ObjectTypes';
const FETCH_AUTO_ASSOCIATIONS_FOR_ACTIVITY = registerQuery({
  fieldName: 'autoAssociationsData',
  args: ['subjectObjectTypeId', 'subjectObjectId', 'engagementType', 'includedObjects', 'apiClient'],
  fetcher: ({
    subjectObjectTypeId,
    subjectObjectId,
    engagementType,
    includedObjects,
    apiClient
  }) => apiClient.post('/crm-associations-features/v3/auto-associations', {
    data: {
      subjectObjectTypeId,
      subjectObjectId,
      engagementType,
      includedObjects
    }
  })
});
const FETCH_AUTO_ASSOCIATIONS_FOR_ACTIVITY_MULTIPLE = registerQuery({
  fieldName: 'autoAssociationsData',
  args: ['subjectObjectTypeId', 'subjectObjectIds', 'engagementType', 'includedObjects', 'apiClient'],
  fetcher: ({
    subjectObjectTypeId,
    subjectObjectIds,
    engagementType,
    includedObjects,
    apiClient
  }) => apiClient.post('/crm-associations-features/v3/auto-associations', {
    data: {
      subjectObjectTypeId,
      subjectObjectIds,
      engagementType,
      includedObjects
    }
  })
});
const formatEngagementType = engagementOrInteractionType => {
  // some host apps may pass CDO's ObjectType FQN `MEETING_EVENT` instead of CDO's
  // EngagementType `MEETING` which is the BE's expected value
  // NOTE: This is a different expectation than useFetchUniversalEngagementAssociations, which expects `MEETING_EVENT` instead of `MEETING`
  if (engagementOrInteractionType === MEETING_EVENT) {
    return MEETING;
    // some host apps may pass CDO's EngagementType `INCOMING_EMAIL`, `FORWARDED_EMAIL`, or `EMAIL_ACTIVITY` instead of CDO's
    // ObjectType FQN `EMAIL` which is the BE's expected value
  } else if (engagementOrInteractionType === INCOMING_EMAIL || engagementOrInteractionType === FORWARDED_EMAIL || engagementOrInteractionType === EMAIL_ACTIVITY) {
    return EMAIL;
    // some host apps may pass CDO's EngagementType `CUSTOM_CHANNEL_CONVERSATION` instead of CDO's
    // ObjectType FQN `COMMUNICATION` which is the BE's expected value
  } else if (engagementOrInteractionType === CUSTOM_CHANNEL_CONVERSATION) {
    return COMMUNICATION;
  }
  return engagementOrInteractionType;
};
export const useFetchAutoAssociations = ({
  subjectObjectTypeId,
  subjectObjectId,
  subjectObjectIds = [],
  engagementType,
  skip,
  apiClient = http
}) => {
  // Determine single vs. multiple query
  const useMultipleQuery = Boolean(subjectObjectIds.length > 0);

  // Use multiple query only if subjectObjectIds is provided
  const multipleQueryResult = useQuery(FETCH_AUTO_ASSOCIATIONS_FOR_ACTIVITY_MULTIPLE, {
    variables: {
      subjectObjectTypeId: subjectObjectTypeId || '',
      subjectObjectIds,
      engagementType: formatEngagementType(engagementType),
      includedObjects: {},
      apiClient
    },
    fetchPolicy: 'network-only',
    skip: skip || !useMultipleQuery
  });

  // Keeping single query for backward compatibility
  const singleQueryResult = useQuery(FETCH_AUTO_ASSOCIATIONS_FOR_ACTIVITY, {
    variables: {
      subjectObjectTypeId: subjectObjectTypeId || '',
      subjectObjectId: subjectObjectId || '',
      engagementType: formatEngagementType(engagementType),
      includedObjects: {},
      apiClient
    },
    fetchPolicy: 'network-only',
    skip: skip || useMultipleQuery
  });

  // Return the appropriate result based on which query was used
  return useMultipleQuery ? multipleQueryResult : singleQueryResult;
};